import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Dialog from 'components/ContextDialog';
import Literal from '../../../../../components/Literal';
import { CancelIcon } from '../../../../../components/icons';
import './ErrorImageSizeDialog.scss';
import styles from './ErrorImageSizeDialogStyles';
import { ButtonPrimary } from '../../../../../components/buttons';

class ErrorImageSizeDialog extends Component {
    state = { scale: 1.2 };

    _renderTitleDialog = () => {
        return (
            <div className="errorImageSizeDialogHeader">
                <Literal literal="error_uploading_photo" />
                <CancelIcon onClick={() => this.props.onAccept()} />
            </div>
        );
    };

    renderFooter = () => {
        const { onAccept } = this.props;
        return (
            <div className="footer-dialog">
                <ButtonPrimary onClick={onAccept}>
                    <Literal literal="action_accept" />
                </ButtonPrimary>
            </div>
        );
    };

    render() {
        const { show, onClose, onAccept } = this.props;
        let renderFooter = this.renderFooter();
        return (
            <Dialog
                title={this._renderTitleDialog()}
                open={show}
                onRequestClose={onClose}
                className="errorImageSizeDialog dialogBlockOutsideClick"
                titleClassName="header-dialog"
                bodyClassName="body-dialog"
                contentStyle={styles.contentDialog}
                autoScrollBodyContent={true}
            >
                <div style={{ padding: 30 }}>
                    <Literal literal={'label_photo_too_big'} />
                </div>
                {renderFooter}
            </Dialog>
        );
    }
}

ErrorImageSizeDialog.propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
};

export default ErrorImageSizeDialog;
